import img10 from '../.././Image/img10.PNG'
import img12 from '../.././Image/img12.png'
import img4 from '../.././Image/img4.PNG'
import img18 from '../.././Image/IMG_3190.PNG'

function Product() {
    return (
        <>
            <div className="inline-grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 justify-center place-items-center">

                <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow w-[300px] h-[300px]">
                    <img
                        src={img12}
                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                    />
                </div>

                <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow w-[300px] h-[300px]">
                    <img
                        src={img10}
                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                    />
                </div>

                <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow w-[300px] h-[300px]">
                    <img
                        src={img4}
                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                    />
                </div>
                 <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 w-[300px] h-[300px]">
                                    <img src={img18} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                                </div>

            </div>


            <div className="text-white mx-4 sm:mx-10 md:mx-[80px] font-sans leading-relaxed mt-10 sm:mt-14 md:mt-16">

                <h1 className="text-center text-2xl sm:text-3xl md:text-4xl font-extrabold mb-10 sm:mb-14 md:mb-16 
                    bg-gradient-to-r from-purple-400 to-blue-400 text-transparent bg-clip-text">
                    Design Documentation
                </h1>

                <div className="inline-grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-10">


                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                     hover:scale-[1.02] transition duration-300 border border-white/10 
                     w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Product Structure Guide
                        </h2>

                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A document outlining the overall architecture of the product — core
                            features, modules, workflows, navigation logic, and functional hierarchy.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                     hover:scale-[1.02] transition duration-300 border border-white/10 
                     w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Product Content Guidelines
                        </h2>

                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            Formal rules for writing all product-related text — feature descriptions,
                            tooltips, labels, onboarding messages, notifications, and microcopy for clarity
                            and consistency.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                    hover:scale-[1.02] transition duration-300 border border-white/10 
                    w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Product Design Framework
                        </h2>

                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            Detailed instructions on product UI elements — layout grids, spacing, colors,
                            typography, interface components, and visual presentation across the product.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                     hover:scale-[1.02] transition duration-300 border border-white/10 
                     w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Product Style Guide
                        </h2>

                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            Defines the product’s tone, writing style, iconography, typography scales,
                            visual standards, and do’s & don’ts for consistent brand expression.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                    hover:scale-[1.02] transition duration-300 border border-white/10 
                    w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Product UI/UX Standards Manual
                        </h2>

                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A comprehensive guide for designing product interfaces — components, interaction
                            patterns, workflows, animations, accessibility requirements, and UX rules.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                    hover:scale-[1.02] transition duration-300 border border-white/10 
                     w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Product Branding Handbook
                        </h2>

                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A compact overview of how the brand appears inside the product — logo placement,
                            color usage, visual hierarchy, branded UI elements, and messaging style.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                     hover:scale-[1.02] transition duration-300 border border-white/10 
                     w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Product Component Library
                        </h2>

                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A collection of reusable product components — buttons, cards, tables, filters,
                            forms, navigation elements, modals, and interactive widgets.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                     hover:scale-[1.02] transition duration-300 border border-white/10 
                     w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Product Identity Manual
                        </h2>

                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            Explains the complete visual and functional identity of the product — templates,
                            typography, image styling, icon sets, and brand-aligned UI behavior.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                     hover:scale-[1.02] transition duration-300 border border-white/10 
                     w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Product Design System & Brand Identity
                        </h2>

                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A unified manual combining branding rules with a scalable design system to
                            support designers and developers.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                    hover:scale-[1.02] transition duration-300 border border-white/10 
                     w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            Product Strategy Guide
                        </h2>

                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A strategic document outlining product goals, user segments, value propositions,
                            feature priorities, user journey flows, and long-term roadmap.
                        </p>
                    </div>



                </div>

            </div>
        </>
    );
}

export default Product;